import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnlyIntegerNumberDirective } from './only-integer-number.directive';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    OnlyIntegerNumberDirective,
  ],
  exports: [
    OnlyIntegerNumberDirective,
   ],
})
export class OnlyIntegerNumberModule { }
